import React from 'react'
import WeatherAlerts from '../components/WeatherAlerts'
import { useGardenContext } from '../context/GardenContext'

const WeatherAlertsPage: React.FC = () => {
  const { gardens } = useGardenContext()
  
  // Get the most recent garden's zip code if available
  const lastGarden = gardens.length > 0 ? gardens[gardens.length - 1] : null
  
  return (
    <div style={{ padding: '1rem', maxWidth: '1200px', margin: '0 auto' }}>
      <WeatherAlerts />
      
      {/* Quick Tips */}
      <div className="card" style={{ marginTop: '2rem' }}>
        <h3>🛡️ Weather Protection Tips</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', marginTop: '1rem' }}>
          <div style={{ padding: '1rem', background: '#e3f2fd', borderRadius: '8px' }}>
            <h4>🥶 Frost Protection</h4>
            <ul style={{ fontSize: '0.9rem', margin: '0.5rem 0 0 0', paddingLeft: '1.2rem' }}>
              <li>Water soil before sunset</li>
              <li>Cover with blankets or frost cloth</li>
              <li>Use jugs of hot water under covers</li>
              <li>Harvest ripe produce</li>
            </ul>
          </div>
          
          <div style={{ padding: '1rem', background: '#fff3e0', borderRadius: '8px' }}>
            <h4>🌡️ Heat Protection</h4>
            <ul style={{ fontSize: '0.9rem', margin: '0.5rem 0 0 0', paddingLeft: '1.2rem' }}>
              <li>Water deeply in early morning</li>
              <li>Provide 30-50% shade cloth</li>
              <li>Mulch to retain moisture</li>
              <li>Harvest heat-sensitive crops</li>
            </ul>
          </div>
          
          <div style={{ padding: '1rem', background: '#f3e5f5', borderRadius: '8px' }}>
            <h4>⛈️ Storm Protection</h4>
            <ul style={{ fontSize: '0.9rem', margin: '0.5rem 0 0 0', paddingLeft: '1.2rem' }}>
              <li>Stake and secure tall plants</li>
              <li>Harvest ripe produce</li>
              <li>Move containers to shelter</li>
              <li>Ensure drainage is clear</li>
            </ul>
          </div>
          
          <div style={{ padding: '1rem', background: '#e8f5e9', borderRadius: '8px' }}>
            <h4>💨 Wind Protection</h4>
            <ul style={{ fontSize: '0.9rem', margin: '0.5rem 0 0 0', paddingLeft: '1.2rem' }}>
              <li>Stake tomatoes and peppers</li>
              <li>Reinforce trellises</li>
              <li>Cluster containers together</li>
              <li>Create windbreaks</li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Emergency Kit Checklist */}
      <div className="card" style={{ marginTop: '1rem' }}>
        <h3>🎒 Emergency Garden Kit</h3>
        <p style={{ color: '#666', marginTop: '0.5rem' }}>
          Keep these items ready for quick response to weather emergencies:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.5rem', marginTop: '1rem' }}>
          {[
            '☐ Frost cloth or old blankets',
            '☐ Stakes and plant ties',
            '☐ Shade cloth (30-50%)',
            '☐ Extra pots/containers',
            '☐ Mulch (straw or wood chips)',
            '☐ Row cover hoops',
            '☐ Clothespins or clips',
            '☐ Emergency tarps',
            '☐ Milk jugs (for hot water)',
            '☐ Outdoor extension cords',
            '☐ Pruning shears',
            '☐ Harvest baskets'
          ].map((item, idx) => (
            <div key={idx} style={{ padding: '0.5rem', fontSize: '0.9rem' }}>
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WeatherAlertsPage
